"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const TrialsServiceClient_1 = __importDefault(require("./TrialsServiceClient"));
exports.default = TrialsServiceClient_1.default;
var PremiumTrialsNotFoundError_1 = require("./errors/PremiumTrialsNotFoundError");
exports.PremiumTrialsNotFoundError = PremiumTrialsNotFoundError_1.default;
var PremiumTrialUnavailableError_1 = require("./errors/PremiumTrialUnavailableError");
exports.PremiumTrialUnavailableError = PremiumTrialUnavailableError_1.default;
